import './_internal/CasToolbar.scss';

import { IGeneralObjectType } from 'src/compass/site/util';

import { CasStackRow } from '../CasStack/CasStackRow';
import CasToolbarExport from './_internal/CasToolbarExport';

type CasToolbarProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  exportEntity?: string;
  exportParams?: IGeneralObjectType;
};

export default function CasToolbar({
  left,
  right,
  exportEntity,
  exportParams = {},
}: CasToolbarProps) {
  const empty =
    (left === undefined || (Array.isArray(left) && left.length === 0)) &&
    (right === undefined || (Array.isArray(right) && right.length === 0));

  return (
    <CasStackRow
      alignItems="center"
      justifyContent="space-between"
      className={`CasToolbar ${empty ? 'empty' : ''}`}
    >
      <CasStackRow alignItems="center">{left}</CasStackRow>
      <CasStackRow alignItems="center">
        {right}
        {exportEntity && <CasToolbarExport entity={exportEntity} params={exportParams} />}
      </CasStackRow>
    </CasStackRow>
  );
}
